import React from 'react'
import styles from './Homepage.module.css'
import HomeHeroSection from '../../sections/HomeHeroSection/HomeHeroSection'
import WelcomeSection from '../../sections/WelcomeSection/WelcomeSection'
import RichTextSection from '../../sections/RichTextSection/RichTextSection'
import GalleryCarousel from '../../sections/GalleryCarousel/GalleryCarousel'
import OpenHoursSection from '../../sections/OpenHoursSection/OpenHoursSection'
import TestimonialsSection from '../../sections/TestimonialsSection/TestimonialsSection'
import HomeBannerSection from '../../sections/HomeBannerSection/HomeBannerSection'
import BrewsSection from '../../sections/BrewsSection/BrewsSection'
import EventsShowcase from '../../sections/EventsShowcase/EventsShowcase'
import ArtistGallery from '../../sections/ArtistGallery/ArtistGallery'
import SpecialPopup from '../../sections/SpecialPopup/SpecialPopup'

// Papon concert promo is visible until 10 Oct 2026, 11:59:59 PM (India time)
const PROMO_END = new Date('2026-10-10T23:59:59+05:30')

const Homepage = () => {
    const showPromo = new Date() <= PROMO_END

    return (
        <>
            {/* Popup: opens 5 seconds after the page loads */}
            {showPromo && <SpecialPopup />}

            <HomeBannerSection />
            <HomeHeroSection />
            <WelcomeSection />

            {/* Section: shown in the page, right after the Welcome section */}
            {showPromo && <SpecialPopup mode="section" id="papon-concert" />}

            {/* <RichTextSection /> */}
            <EventsShowcase />
            <ArtistGallery />
            <BrewsSection />
            <OpenHoursSection />
            <GalleryCarousel />
            <TestimonialsSection />
        </>
    )
}

export default Homepage